import { EventsBusService } from '../../shared/eventsBus.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { FeedbacksService } from '../shared/feedbacks.service';
import { Feedback } from '../shared/feedbacks.model';
import { Component, OnInit, Input, ViewChildren } from '@angular/core';
import { ChatsService } from '../../chats/shared/chats.service';

import * as L from 'leaflet';

@Component({
  selector: 'app-feedback-detail',
  templateUrl: './feedback-detail.component.html',
  styleUrls: ['./feedback-detail.component.scss']
})
export class FeedbackDetailComponent implements OnInit {
  @ViewChildren('container') container;
  feedback: Feedback;
  currentFeedbackStringly: string;
  editMode = false;
  public assignment: any = {};
  zones = ['Đường thủy', 'Đường bộ'];

  @Input()
  set fb(fb: Feedback) {
    if (!fb) {
      this.feedback = fb;
    } else {
      if (this.feedback && this.feedback._id !== fb._id) {
        this.feedback.userInfo.isAnonymous = this.isAnonymous;
      }
      this.feedback = fb;
      this.isAnonymous = this.feedback.userInfo.isAnonymous;
      setTimeout(() => {
        this.setMapView(this.feedback);
      }, 300);
      if (this.feedback && this.feedback.images.length > 0) {
        this.currentImage = this.feedback.images[0];
      }

      this.openDropdown = false;
      this.openZoneDropdown = false;

      this.currentFeedbackStringly = JSON.stringify(fb);
    }
  }
  get fb() {
    return this.feedback;
  }

  types: any[];
  currentImage: string;
  isAnonymous: boolean;

  openDropdown = false;
  openZoneDropdown = false;
  private map: L.Map;
  private marker: L.Marker;
  constructor(
    private service: FeedbacksService,
    private chatService: ChatsService,
    private route: ActivatedRoute,
    private router: Router,
    private eventsBus: EventsBusService
  ) { }

  setMapView(feedback: Feedback) {
    if (feedback && this.map && feedback.geo) {
      const coordinates = feedback.geo.geometry.coordinates;
      this.map.setView([coordinates[1], coordinates[0]], 16);
      if (this.marker) {
        this.map.removeLayer(this.marker);
      }
      this.marker = new L.Marker([coordinates[1], coordinates[0]], {
        icon: new L.Icon({
          iconUrl: 'assets/images/marker-icon.png',
          iconSize: [25, 41],
          iconAnchor: [12.5, 41]
        }),
        draggable: false
      }).addTo(this.map);

      this.marker.on('dragend', function (e) {
        feedback.geo.geometry.coordinates = [e.target.getLatLng().lng, e.target.getLatLng().lat];
      });

      this.marker.dragging.addHooks();
    }
  }

  setEditMode(status) {
    if (status) {
      this.marker.dragging.enable();
    }
    this.editMode = status;
  }

  toggleDropdown(status) {
    this.openDropdown = !status;
  }

  toggleZoneDropdown(status) {
    this.openZoneDropdown = !status;
  }

  initMap(_this: this) {
    // if (!_this.map) {
    this.map = L.map('map', {
      center: L.latLng(10.777093006214637, 106.69547438621521),
      zoom: 16,
      attributionControl: false,
      scrollWheelZoom: false
    });
    L.tileLayer('//map.thongtingiaothong.vn/transport-full/{z}/{x}/{y}.png', {}).addTo(this.map);
    // }
  }

  ngOnInit() {
    this.eventsBus.updateFeedback.subscribe(() => {
      this.route.params
        .map(p => p.id)
        .do(() => (this.editMode = false))
        .do(() => (this.fb = null))
        .filter(id => !!id)
        .flatMap(id => this.service.get(id))
        .subscribe((fb: Feedback) => {
          this.fb = fb;
          setTimeout(() => this.initMap(this), 200);
        });
    });

    this.route.params
      .map(p => p.id)
      .do(() => (this.editMode = false))
      .do(() => (this.fb = null))
      .filter(id => !!id)
      .flatMap(id => this.service.get(id))
      .subscribe((fb: Feedback) => {
        this.fb = fb;
        setTimeout(() => this.initMap(this), 200);
      });

    this.service
      .getAllTypes()
      .do(types => (this.types = types))
      .subscribe();
  }

  chooseImage(image) {
    this.currentImage = image;
  }

  getTypeValue(id, key) {
    let value = '';
    if (this.types && this.types.length > 0) {
      this.types.forEach(type => {
        if (id === type._id) {
          value = type[key];
        }
      });
    }
    return value;
  }

  assign(fb: Feedback, action: string, assignment: any) {
    this.service.assign(fb._id, action, assignment).subscribe(console.info, console.error);
  }

  goToChat() {
    if (!this.feedback.chatId) {
      const chatObject = {
        userInfo: this.feedback.userInfo,
        messages: []
      };
      this.chatService.create(chatObject).subscribe(chat => {
        this.feedback.chatId = chat._id;
        this.service.createChatroom(this.feedback._id, chat._id).subscribe(fb => {
          this.router.navigate(['chat', this.feedback.chatId]);
        });
      });
    } else {
      this.router.navigate(['chat', this.feedback.chatId]);
    }
  }

  save(feedback: Feedback) {
    this.service
      .update(feedback._id, feedback)
      .do(() => (this.editMode = false))
      .subscribe(fb => {
        this.currentFeedbackStringly = JSON.stringify(fb);
        this.eventsBus.updateFeedback.emit();
      });
  }

  private _startChat$() {
    const chatObject = {
      userInfo: this.feedback.userInfo,
      messages: []
    };
    return this.chatService
      .create(chatObject)
      .do(chat => {
        this.feedback.chatId = chat._id;
      })
      .flatMap(chat => this.service.createChatroom(this.feedback._id, chat._id));
  }

  startChat() {
    if (!this.feedback.chatId) {
      this._startChat$().subscribe(feedback => {
        this.feedback.chatId = feedback.chatId;
      });
    }
  }

  chooseType(type: any, status) {
    this.toggleDropdown(status);
    this.feedback.type = type._id;
  }

  chooseZone(zone: any, status) {
    this.toggleZoneDropdown(status);
    this.feedback.zone = zone;
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/feedbacks/feedback-detail/feedback-detail.component.ts